import React from 'react';
import {
  Statistic,
} from 'semantic-ui-react';
import {
  Other,
} from 'simplydo/interfaces';
import util from 'utils/utils';
import styled from 'styled-components';

const StatisticContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  margin: 1rem 0;
  width: 100%;
  flex-wrap: wrap;
  .ui.statistic {
    margin-bottom: 0;
  }
`;

export type IImpactMeasure = (Other.IImpact & { laneTotalImpactValue?: number, laneDropdownImpactValues?: { [key: string]: number } });

const ImpactStatistics = ({
  impactMeasures,
}: {
  impactMeasures: IImpactMeasure[],
}) => (
  <StatisticContainer>
    {impactMeasures.map((impactMeasure) => {
      if (impactMeasure.type === 'dropdown' && impactMeasure.laneDropdownImpactValues) {
        return Object.entries(impactMeasure.laneDropdownImpactValues).map(([key, value]) => (
          <Statistic
            key={`${impactMeasure._id}-${key}`}
          >
            <Statistic.Label>Saving...</Statistic.Label>
            <Statistic.Value>{value}</Statistic.Value>
            <Statistic.Label>{key}</Statistic.Label>
          </Statistic>
        ));
      }
      if (impactMeasure?.laneTotalImpactValue) {
        const usingValue = (impactMeasure.type === 'time' ? util.convertToDayOrWeek(impactMeasure.laneTotalImpactValue) : impactMeasure.laneTotalImpactValue);
        const usingTitle = (impactMeasure.type === 'time' ? '' : impactMeasure.name);

        return (
          <Statistic
            key={impactMeasure._id}
          >
            <Statistic.Label>{impactMeasure.effect === 'cost' ? 'Costs...' : 'Saving...'}</Statistic.Label>
            <Statistic.Value>{impactMeasure.effect === 'cost' ? '-' : ''}{typeof usingValue === 'number' ? usingValue.toLocaleString() : usingValue}</Statistic.Value>
            <Statistic.Label>{usingTitle ? `${usingTitle} annually` : 'Annually'}</Statistic.Label>
          </Statistic>
        );
      }
      return null;
    })}
  </StatisticContainer>
);

export default ImpactStatistics;
